import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "bootstrap-icons/font/bootstrap-icons.css"; // Ensure Bootstrap Icons are available

const Testimonial = () => {
  return (
    <section id="testimonial" className="testimonials section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Pagination, Autoplay]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          className="init-swiper"
        >
          <SwiperSlide>
            <div className="testimonial-item">
              <img src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/user-244.png" className="testimonial-img" alt="Saul Goodman" />
              <h3>HRS Murthy</h3>
              <h4>Ceo &amp; Founder</h4>
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill"></i>
                ))}
              </div>
              <p>
                <i className="bi bi-quote quote-icon-left"></i>
                <span>
                  At MMCS, we are dedicated to revolutionizing document-centric business environments with innovative
                  solutions. Our focus on security, workflow automation, and seamless integration ensures efficiency
                  for our clients in banking, insurance, and professional industries.
                </span>
                <i className="bi bi-quote quote-icon-right"></i>
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="testimonial-item">
              <img src="https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/user-244.png" className="testimonial-img" alt="Sara Wilsson" />
              <h3>Sujatha</h3>
              <h4>HR</h4>
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill"></i>
                ))}
              </div>
              <p>
                <i className="bi bi-quote quote-icon-left"></i>
                <span>
                  At MMCS, we believe in fostering a culture of collaboration and innovation. Our team thrives on
                  integrity, dedication, and a shared commitment to delivering exceptional software solutions
                  for document management and workflow automation.
                </span>
                <i className="bi bi-quote quote-icon-right"></i>
              </p>
            </div>
          </SwiperSlide>

          {/* Add more SwiperSlide components here for additional testimonials */}

        </Swiper>

        {/* Pagination Dots */}
        <div className="swiper-pagination"></div>
      </div>
    </section>
  );
};

export default Testimonial;
